import Button from "@material-ui/core/Button";
import useDashboardEditor from "MyDashboards/state/editor";
import { Slide } from "MyDashboards/state/editorTypes";
import { Dashboard } from "MyDashboards/types/api";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as InstructionsImgAr } from "../../assets/BuildDashboardArabic.svg";
import { ReactComponent as AddIcon } from "../../assets/addIcon.svg";
import { ReactComponent as InstructionsImg } from "../../assets/create_dashboard_instructions.svg";
import { ReactComponent as ImportIcon } from "../../assets/importIcon.svg";
import AddSlideModal from "../AddSlideModal/AddSlideModal";
import ImportDashboardModal from "../ImportDashboardModal/ImportDashboardModal";
import useSlidesViewStyles from "./themes";

const InstructionsSlide = () => {
  const classes = useSlidesViewStyles();
  const { t } = useTranslation();
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const addPage = useDashboardEditor((e) => e.addPage);
  const onLayoutSelected = (layout: Slide) => {
    setIsAddModalOpen(false);
    addPage(layout);
  };
  const { rtl } = useAppContext();
  const onDashboardSelected = (dashboard: Dashboard) => {
    setIsImportModalOpen(false);
    dashboard.dashboardData?.pages.forEach((p) => addPage(p));
  };
  return (
    <div className={classes.instructionsSlide}>
      <div className="title">{t("myStories.Build a Story")}</div>
      {rtl ? <InstructionsImgAr /> : <InstructionsImg />}

      <div className="actions">
        <Button className="addBtn" onClick={() => setIsAddModalOpen(true)}>
          <>
            <AddIcon />
            <span>{t("myStories.Add slide")}</span>
          </>
        </Button>

        <Button
          className="importBtn"
          onClick={() => setIsImportModalOpen(true)}
        >
          <>
            <ImportIcon />
            <span>{t("myStories.Import slides")}</span>
          </>
        </Button>
      </div>

      <AddSlideModal
        open={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        onLayoutSelected={onLayoutSelected}
      />
      <ImportDashboardModal
        open={isImportModalOpen}
        onClose={() => setIsImportModalOpen(false)}
        onDashboardSelected={onDashboardSelected}
      />
    </div>
  );
};
export default InstructionsSlide;
